import React from 'react';
import { createGlobalStyle } from 'styled-components';
import ArrowLeft from '../../assets/Menu/arrowLeft.svg';
import TabsComponent from '../../components/common/component/TabsComponent';
import CollectionPoolDescription from './description/CollectionPoolDescription';
import CollectionPoolIndicator from './indicator/CollectionPoolIndicator';
import IconComponent from '../../components/common/component/IconComponent';
import Container from '../../../node_modules/saur_ui_library/src/Atoms/Container/Container';
import { useNavigate } from 'react-router-dom';

interface TabProps {
  label: string;
  content: React.JSX.Element;
}

// Style icon
const divStylesMainIcons = {
  display: 'inline-flex',
  alignSelf: 'center',
  width: '4vh',
  alignItems: 'center',
  cursor: 'pointer',
  color: 'black',
  marginTop: '35px',    
  marginBottom: '20px'
};

function CollectionPoolDetail() {
  const navigate = useNavigate();

  // Go back function
  const GoBack = () => {
    navigate(-1);
  };

  // Tabs Props Array
  const tabs: TabProps[] = [
    {
      label: 'Description',
      content: (
        <>
          <CollectionPoolDescription />
        </>
      ),
    },
    {
      label: 'Indicateurs',
      content: (
        <>
          <CollectionPoolIndicator />
        </>
      ),
    },
  ];
  return (
    <Container className='sds-reset-style collection_pool_container'>
      <Styles />
      <Container className='collection_pool_title'>
        <IconComponent
          icon={ArrowLeft}
          divStyles={divStylesMainIcons}
          imgStyles={{
            marginRight: '10px',
            marginLeft: '5px',
            marginBottom: '5px',
          }}
          titleStyles={{
            marginBottom: '5px',
          }}
          title={window.sessionStorage.getItem('collectionPoolName')}
          event={() => GoBack()}
        />
      </Container>
      <div className='collection_pool'>
        <TabsComponent tabs={tabs} />
      </div>
    </Container>
  );
}

const Styles = createGlobalStyle`
    .collection_pool_container {
      width: 80%;
      
      .collection_pool_title {
        .iconComponent {
          align-self: flex-start !important;
          margin-left: 400px;
          margin-bottom: 15px;
          width: auto !important;
          
          span {
            font-weight: bold;
          }
        } 
      }
      
      .collection_pool {
        background-color: #FFFFFF;
        border-radius: 15px;
        box-shadow: 0 14px 14px 3px rgba(18, 26, 49, 0.05);
        width: 90%;
        height: 90vh;
        margin-left: 400px;
      }
      
      .button-container {
        justify-content: flex-start !important;
        padding-top: 25px;
        margin-left: 50px;
      }
    }
`;

export default CollectionPoolDetail;
